import { createRouter, createWebHistory } from 'vue-router';
import CheckoutCart from '@/views/CheckoutCart.vue';
import { useCheckoutStore } from '@/stores/checkout';

const quantityLimit = Number(import.meta.env.VITE_QUANTITY_LIMIT);

const routes = [
  {
    // while checkout is the only available view, all paths should lead to it
    path: '/:catchAll(.*)*',
    redirect: '/checkout/',
  },
  {
    path: '/checkout/',
    name: 'CheckoutCart',
    component: CheckoutCart,
    meta: {
      title: 'Checkout',
    },
    props: route => ({
      plan: route.query.plan,
      coupon: route.query.coupon,
      quantity: Number(route.query.quantity) || 1,
      servers: Number(route.query.servers) || 0,
      inapp: Number(route.query.inapp) || 0,
      couponFocus: Boolean(route.query.couponFocus),
    }),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(to => {
  // ex: ?plan=a&plan=b are parsed as arrays by vue router, so squash to first value
  for (const key in to.query) {
    if (Array.isArray(to.query[key])) {
      to.query[key] = to.query[key][0];
    }
  }

  if (to.name === 'CheckoutCart' && !to.query.plan) {
    to.query.plan = 'speedify-unlimited-monthly';
  }

  if (to.query.coupon) {
    to.query.coupon = to.query.coupon.trim().toLowerCase();
  }

  if (to.query.quantity) {
    to.query.quantity = Number(to.query.quantity);
  }
  if (to.query.servers) {
    to.query.servers = Number(to.query.servers);
  }
  if (to.query.inapp) {
    to.query.inapp = Number(to.query.inapp);
  }

  if (to.query.quantity > quantityLimit) {
    to.query.quantity = quantityLimit;
  }
  if (to.query.servers > quantityLimit) {
    to.query.servers = quantityLimit;
  }
});

router.afterEach((to, from) => {
  const checkoutStore = useCheckoutStore();
  if (to.path === '/checkout/') {
    const serverCodeInterval = to.query.plan?.includes('monthly') ? 'monthly' : 'yearly';
    const newCheckoutData = {
      plan: to.query.plan || '',
      quantity: to.query.quantity || 1,
      servers: to.query.servers || 0,
      serverCode: to.query.serverCode || `speedify-dedicated-server-${serverCodeInterval}`,
    };
    // the cart is changing, so any error from a purchase attempt on the old cart is stale
    checkoutStore.resetPaymentErrors();
    // this way, going forward and back in browser history actually updates the cart
    checkoutStore.update(newCheckoutData);
    checkoutStore.getPlanDescription();
  }

  if (to.meta?.title) {
    document.title = `${to.meta.title} | Speedify`;
  }
});

export default router;
